import eventManager from "../../store/sqftEventManager";
import config from "../../store/sqftConfig";
//import Menu from "./menu";
import workspace from "../workspace";
import $ from "jquery";
import {iconPlusBlue} from "../../../../assetsSQFT";
import {attachResource} from "./resourseCanas";
import {RESOURCE_ATTACHED_TO_TYPE, SIDEBAR_NAVIGATION_BUTTONS} from "../../../../constants";
import store from "../../../../../../store";

export default new function() {
  let self = this;

  //public functions
  this.init = function() {

    // $('[data-group]').preBind('click', deregisterEvents);
  };

  this.addBumpout_onClick = function() {
    self.setCursorImage();
    if (window.innerWidth < 991 && !config.tutorialIsRunning) {
      //todo sqft-react
      //Menu.hideSideBarContent(); // hide sidebar menu
    }
  };
  this.resetAllBumpouts = function() {
    workspace.removeAllBumpouts()
  };

  this.registerEvents = function() {
    eventManager.addEvent(
      eventManager.events.RENDER,
      self.renderCursor,
      self,
      eventManager.priorities.OVERALL
    );
    // eventManager.addEvent(
    // 	eventManager.events.MOUSE_DOWN,
    // 	self.onMouseDown,
    // 	self,
    // 	eventManager.priorities.OVERALL
    // );
    eventManager.addEvent(
      eventManager.events.MOUSE_UP,
      self.onMouseUp,
      self,
      eventManager.priorities.OVERALL
    );
  };

  this.onMouseUp = function(mousePos) {
    void mousePos;
    let hoverShape = workspace.getHoverShape();
    if (hoverShape && hoverShape.getHoverSegment) {
      const reduxState = store.getState();
      const activeButton = reduxState.sqftMenuState.activeButton;
      if (activeButton !== SIDEBAR_NAVIGATION_BUTTONS.bumpout) {
        return
      }

      let seg = hoverShape.getHoverSegment();
      if (seg && (!seg.isWithBumpout() || !seg.isWithMitered())) {
        attachResource(seg, null, RESOURCE_ATTACHED_TO_TYPE.bumpout, null, null,'');
        // let attachedTo = workspace.getAttachedTo(seg);
        // if (attachedTo) {
        //   workspace.removeShape(attachedTo);
        // }
        // todo
        // var newLines = [new line(new)];
        // hoverShape.addLines(newLines);
        // hoverShape.splitLine(mousePos,seg);

        //todo fix bumpout rotation and remove this
        ////////////////////////////////////////////////
        // var isRotateAngleParts = false;
        // hoverShape.rotateAngleParts.forEach((anglePart) => {
        //   if(anglePart.rotatedAngleValue > 0) {
        //     isRotateAngleParts = true
        //   }
        // });
        // if (isRotateAngleParts) return;
        ///////////////////////////////////

        // let historyCallBack = seg.addBumpoutToLine.bind(self, mousePos); // cursorName, self.cursorImage.image.dataset.id
        //
        // workspace.addImage(self.cursorImage.image, self.cursorImage.width /  scale, self.cursorImage.height / scale, seg, hoverShape, 'bumpout', historyCallBack);
        // historyCallBack();

        // config.highlight.lines = true;
        //todo
        deregisterEvents();
        //todo sqft-react
        //Menu.removeActiveClassFromAllButtons();
      } else {
        //todo sqft-react
        //Menu.openMenu();
        // 	deregisterEvents();
        // 	elements.designDefault.click();
      }
    }

    //todo
    self.checkForRestoreCursor();
  };

  this.setCursorImage = function () {
    // const alreadyAddedImage = self.addedImages.find(image => image.dataset.id === self.clickedEdgeButton.attr("data-id"));
    // if (alreadyAddedImage) {
    //   self.cursorImage = { image: alreadyAddedImage, width: alreadyAddedImage.width, height: alreadyAddedImage.height };
    //   eventManager.setCursor('edge-select', self, true);
    //   self.registerEvents();
    // } else {
      this.addCursorImage();
    // }
  };

  this.addCursorImage = function () {
    //var item = self.clickedBackSplashButton // remember it to restore after moving canvas cursor switch
    let bounds = 18,
      imgWidth = bounds,
      imgHeight = bounds;

    var domImg = document.createElement('img');
    domImg.crossOrigin = "Anonymous";

    var $img = $(domImg);
    $img.css({
      position: 'absolute',
      width: '1px',
      height: '1px'
    });
    // $img.attr({
    //   'data-id': item.attr('data-id'),
    //   'data-name': item.attr('data-name').trim(),
    //   'data-name-metric': item.attr('data-name-metric').trim(),
    // });
    function imgOnLoad() {
      var bounds = 18;
      let ratio;
      if(imgWidth > imgHeight) {
        ratio = imgHeight / imgWidth;
        imgWidth = bounds;
        imgHeight = bounds * ratio;
      } else {
        ratio = imgWidth / imgHeight;
        imgHeight = bounds;
        imgWidth = bounds * ratio;
      }
      eventManager.setCursor('edge-select', self, true);
      self.cursorImage = { image: domImg, width: imgWidth, height: imgHeight };
      self.registerEvents(); // only after image is load!
    }
    $img.on('load', imgOnLoad);
    $img.appendTo($('body'));

    config.highlight.type = 'backsplash';
    $img.attr('src', iconPlusBlue);

    // config.highlight.id = item.attr('data-id');
  };
  this.checkForRestoreCursor = function() {
    if (self.isWaitingToRestoreCursor) {
      self.isWaitingToRestoreCursor = false;
      eventManager.removeEvent(self, eventManager.events.MOUSE_UP); //remove mouse up, it will be added in setCursorImage

      //todo
      // self.setHighlighting();
      self.setCursorImage();
    }
  };
  this.renderCursor = function(ctx) {
    if(self.cursorImage.image && ($(window).width() > 768)) {
      var mPos = eventManager.LastKnownMousePos;
      if(mPos) {
        ctx.drawImage(self.cursorImage.image, mPos.x + 10, mPos.y + 10, 18, 18);
      }
    }
  };
  this.destroy = function(protect, revertBackAfterMouseUp) {
    if (revertBackAfterMouseUp) {
      eventManager.removeEvent(self, eventManager.events.RENDER); //remove render only, but wait for mouse up to set cursor again
      this.isWaitingToRestoreCursor = true;
    } else {
      deregisterEvents();
    }
    this.hide();
  };
  this.hide = function(e) {
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    //todo sqft-react
    //Menu.hideSideBarContent(); // hide sidebar menu
  };
  function deregisterEvents() {
    eventManager.resetCursor(self);
    eventManager.removeEvent(self);
    config.highlight.lines = false;
  }
};
